import { UserListItemContent } from '../../../ListItem'

// Widget rows keep the base name/e-mail colors on hover — only the row
// background reacts, unlike select list items.
function ProfileUsersWidgetItemContent(props) {
  return <UserListItemContent {...props} isHovered={false} />
}

export default ProfileUsersWidgetItemContent
